import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const styles = {
  root: {
    color: green[600],
    '&$checked': {
      color: green[500],
    },
  },
  checked: {},
};

function LabeledCheckbox(props) {
  const { classes } = props;
    return (
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.checked}
              onChange={props.onChange(props.index)}
              value={props.value}
              color="secondary"
            />
          }
          label={props.label}
        />
      </FormGroup>
    );
  }


LabeledCheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LabeledCheckbox);



// WEBPACK FOOTER //
// ./src/components/Settings/LabeledCheckbox.js